<template>
  <div id="app">
    <Navbar/>
    <section>
      <router-view/>
    </section>
     <Footer/> 
  </div>
</template>

<script src="https://www.gstatic.com/firebasejs/4.13.0/firebase.js"></script>
<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: {
    Navbar,
    Footer
  },
  computed: {
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== "undefined"
      );
    }
  }
};
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue